export function NavCornerIcon({ className }: { className?: string }) {
  return (
    <svg
      width="7"
      height="7"
      viewBox="0 0 8 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M5.3052 0H7.25735L7.25735 1.95215H5.3052L5.3052 0Z" fill="currentColor" />
      <path d="M5.3052 1.95215H7.25735L7.25735 7H5.3052L5.3052 1.95215Z" fill="currentColor" />
      <path d="M0.257355 0H5.3052L5.3052 1.95215H0.257355L0.257355 0Z" fill="currentColor" />
    </svg>
  )
}
